module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"CreateSuccess":"La règle a bien été créée"}}')
  delete Component.options._Ctor
}
